module.exports = __webpack_public_path__ + "static/media/pw.b6909db9.svg";